<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <div>
        <mwp-card-contact [contacts]="contacts" header="Contact List" />
    </div>
</div>